module.exports = __webpack_public_path__ + "media/images/mv2_sp_dummy-dfbe148e7464745a05d00ef71b10683e.png";